
//let api_url = "http://wwww.reboot-the-system.net/php/functions.php";

let api_url = "/php/functions.php";

if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
    api_url = "http://localhost:8888/ansichtssache/php/functions.php";
  }

export const API_URL = api_url;